import { PlanId } from 'domains/models/subscription/planId';
import SubscriptionFeature from 'domains/models/subscription/features';

export default class FormExportFeature extends SubscriptionFeature {
  static currentPlanId = PlanId.Free;
  validPlanId() {
    return FormExportFeature.currentPlanId;
  }

  isValid(planId: PlanId) {
    return planId >= this.validPlanId();
  }
}
